import { useEffect } from "react";

import { IS_ME_LINK } from "@/constants/app";

const GA_ID = IS_ME_LINK ? "G-HXMJ42T4EE" : "G-LNNBBTRGEJ";

interface IWindow {
  dataLayer?: IArguments[];
  gtag: (...args: unknown[]) => void;
}

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));

  return match ? decodeURIComponent(match[2]) : null;
}

function bootstrap() {
  const w = window as IWindow;

  // data transfer to Google Tag Manager
  w.dataLayer = w.dataLayer || [];

  w.gtag = function () {
    w.dataLayer?.push(arguments);
  };

  w.gtag("js", new Date());
  w.gtag("config", GA_ID);

  const isAllowCookies = getCookie("allowCookies") === "1";
  const cookieDetails = getCookie("allowCookieDetails");

  const cookiePreferencesGtag = {
    analyticsCookies: false,
    adsCookies: false,
  };

  if (cookieDetails) {
    try {
      const cookie = JSON.parse(cookieDetails);
      cookiePreferencesGtag.analyticsCookies = !!cookie.analyticsCookies;
      cookiePreferencesGtag.adsCookies = !!cookie.adsCookies;
    } catch {
      console.warn("Invalid allowCookieDetails cookie");
    }
  }

  let otherCookies: "granted" | "denied";
  let analyticsCookies: "granted" | "denied";

  if (isAllowCookies && !cookieDetails) {
    otherCookies = "granted";
    analyticsCookies = "granted";
  } else {
    otherCookies = cookiePreferencesGtag.adsCookies ? "granted" : "denied";
    analyticsCookies = cookiePreferencesGtag.analyticsCookies
      ? "granted"
      : "denied";
  }

  w.gtag("consent", "default", {
    ad_storage: otherCookies,
    ad_user_data: otherCookies,
    ad_personalization: otherCookies,
    analytics_storage: analyticsCookies,
  });
}

function loadScript() {
  const s = document.createElement("script");
  s.async = true;
  s.type = "text/javascript";
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;

  (document.body || document.head).appendChild(s);
}

function useGoogleAnalytics(enabled = false, timeout = 0) {
  useEffect(() => {
    if (!enabled) return;

    bootstrap();

    const timeoutId = window.setTimeout(loadScript, timeout);

    return () => window.clearTimeout(timeoutId);
  }, [enabled, timeout]);
}

export default useGoogleAnalytics;
